import { render, staticRenderFns } from "./ScoreBoard.vue?vue&type=template&id=493f6eb2&scoped=true&"
import script from "./ScoreBoard.vue?vue&type=script&lang=js&"
export * from "./ScoreBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493f6eb2",
  null
  
)

export default component.exports